import ContentLayout from '@/layouts/content-layout'
import ProfileFormView from '@/sections/profile/view/profile-form-view'

export default function ProfileEditPage() {
  return (
    <ContentLayout title="แก้ไขโปรไฟล์" backButton>
      <ProfileFormView />
    </ContentLayout>
  )
}
